export type Tone = 'online' | 'warn' | 'offline' | 'idle'

export function uptimeTone(pct: number | null | undefined): Tone {
  if (pct === null || pct === undefined) return 'idle'
  if (pct >= 100) return 'online'
  if (pct >= 90) return 'warn'
  return 'offline'
}
